import axios from 'axios';
import httpBuildQuery from 'http-build-query';
const BASE_URL = 'api/buildings';

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  count: 0,
  buildings: [],
  loading: false
});

exports.mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_DATA(state, { count, buildings }) {
    state.count = count;
    state.buildings = buildings;
  },
};

exports.actions = {
  async loadList({commit, dispatch}, text) {
    commit('SET_LOADING', true);
    try {
      let res = await axios.get(BASE_URL + (text ? ('?' + httpBuildQuery({ text })) : ''));
      console.log(res.data);
      commit('SET_DATA', {
        count: res.data.count,
        buildings: res.data.buildings
      });
    } catch (err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

export default exports;